import AbstractForecastColumnTemplate from "./AbstractForecastColumnTemplate.js";
import CurrentPeriodForecastColumn from "../instance/CurrentPeriodForecastColumn.js";

/**
 * `CurrentPeriodForecastColumnTemplate` is the editable reference of the concrete
 * CurrentPeriodForecastColumn, which specifies how to compute the current period
 * when interpreting a forecasting template.
 */
export default class CurrentPeriodForecastColumnTemplate extends AbstractForecastColumnTemplate {
	constructor({ isFrozen = false } = {}) {
		super(...arguments);
		this._isFrozen = isFrozen;
	}

	accept(visitor) {
		return visitor.visitCurrentPeriodForecastColumnTemplate(this);
	}

	isCurrentPeriodForecastColumnTemplate() {
		return true;
	}

	_interpretationSpec(interpreter) {
		return {
			...super._interpretationSpec(interpreter),
			isFrozen: this._isFrozen,
		};
	}

	_instanceClass() {
		return CurrentPeriodForecastColumn;
	}

	_makeStartPeriodSpec({ context }) {
		return {
			...super._makeStartPeriodSpec({ context }),
			fiscalYear: context.getFiscalYear(),
		};
	}

	static getType() {
		return "CurrentPeriodForecastColumnTemplate";
	}
}
